import ls from 'lib/core/storageFactory';
import React, { useEffect } from 'react';
import { track } from 'analytics';
import { INFILYTICS_EVENTS } from 'analytics/events';

const Infilytics = () => {
  const client = ls.get('client');
  useEffect(() => {
    track(INFILYTICS_EVENTS.PAGE_VIEWED, {});
  }, []);
  return (
    <iframe
      src={`https://infilytics.infiviz.ai/schema/${client}/views?embed=true?schema=${client}`}
      title="Infilytics"
      style={{ width: '100%', height: '100vh', border: 0 }}
    />
  );
};

export default Infilytics;
